// src/modules/analytics/api.ts
import apiReq from 'core/api';
import type {
  LlmUsageStatItem,
  LlmUsageStatTotal,
  LlmUsageStatByScenarioItem,
  LlmUsageStatsByUserResponse,
  UserStatsParams,
  AnalyticsFilters,
} from './types';

function buildParams(filters: Partial<AnalyticsFilters>): string {
  const params = new URLSearchParams();
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);
  if (filters.project_id) params.set('project_id', filters.project_id);
  if (filters.user_id) params.set('user_id', filters.user_id);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const getStats = async (filters: Partial<AnalyticsFilters>): Promise<LlmUsageStatItem[]> => {
  const data = await apiReq<LlmUsageStatItem[]>(`llm/usage/stats${buildParams(filters)}`);
  return Array.isArray(data) ? data : [];
};

export const getStatsTotal = async (): Promise<LlmUsageStatTotal | null> => {
  const data = await apiReq<LlmUsageStatTotal>('llm/usage/stats-total');
  return data ?? null;
};

export function buildUserStatsQuery(params: UserStatsParams): string {
  const p = new URLSearchParams();
  if (params.date_from) p.set('date_from', params.date_from);
  if (params.date_to) p.set('date_to', params.date_to);
  if (params.project_id) p.set('project_id', params.project_id);
  if (params.scenario_id) p.set('scenario_id', params.scenario_id);
  if (params.query) p.set('query', params.query);
  if (params.sort_column) p.set('sort_column', params.sort_column);
  if (params.sort_direction) p.set('sort_direction', params.sort_direction);
  if (params.limit != null) p.set('limit', String(params.limit));
  if (params.offset != null) p.set('offset', String(params.offset));
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const getStatsByUser = async (
  params: UserStatsParams
): Promise<LlmUsageStatsByUserResponse> => {
  const data = await apiReq<LlmUsageStatsByUserResponse>(
    `llm/usage/stats-by-user${buildUserStatsQuery(params)}`
  );
  return data ?? { count: 0, items: [] };
};

export const getStatsByScenario = async (
  filters: Partial<AnalyticsFilters>
): Promise<LlmUsageStatByScenarioItem[]> => {
  const data = await apiReq<LlmUsageStatByScenarioItem[]>(
    `llm/usage/stats-by-scenario${buildParams(filters)}`
  );
  return Array.isArray(data) ? data : [];
};
